.subscriptionCardContainer {
  padding: var(--cxy-spacing-6) var(--cxy-spacing-4);
}
@media (--cxy-tablet) {
  .subscriptionCardContainer {
    padding: var(--cxy-spacing-7) var(--cxy-spacing-8);
  }
}
@media (--cxy-desktop-mid) {
  .subscriptionCardContainer {
    padding: var(--cxy-spacing-7) 100px;
  }
}
.subscriptionCardContainer .tabsList {
  margin-block-end: var(--cxy-spacing-7);
}

.textContainer {
  padding-block-start: var(--cxy-spacing-6);
}
